module.exports = __webpack_public_path__ + "img/TW_B.1a30d98c.jpg";